import { faEllipsisV } from "@awesome.me/kit-af809b8b43/icons/classic/regular";
import { Button, Menu } from "@flpstudio/design-system";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import type { CommentDto } from "@/api/openapi";
import { useAuth } from "@/hooks/use-auth";

type MENU_OPTION = "EDIT" | "DELETE" | "HIDE" | "UNHIDE";

type Props = {
  comment: CommentDto;
  onMenuClick(option: MENU_OPTION): void;
};

export function ActionMenu(props: Props) {
  const { user, role } = useAuth();

  const isOwnComment =
    Boolean(props.comment.postedBy?.userId) &&
    props.comment.postedBy?.userId === user?.id;
  const isAdmin = role === "admin";
  const isHiddenComment = props.comment.hidden;

  if (!isOwnComment && !isAdmin) {
    return null;
  }

  return (
    <Menu position="bottom-end">
      <Menu.Target>
        <Button
          variant="transparent"
          aria-label="Comment actions"
          className="ml-auto h-fit text-inherit"
        >
          <FontAwesomeIcon icon={faEllipsisV} />
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        {isOwnComment && (
          <>
            <Menu.Item onClick={() => props.onMenuClick("EDIT")}>
              Edit comment
            </Menu.Item>
            <Menu.Item color="red" onClick={() => props.onMenuClick("DELETE")}>
              Delete comment
            </Menu.Item>
          </>
        )}
        {isAdmin && (
          <Menu.Item
            color="red"
            onClick={() =>
              props.onMenuClick(isHiddenComment ? "UNHIDE" : "HIDE")
            }
          >
            {isHiddenComment ? "Unhide comment" : "Hide comment"}
          </Menu.Item>
        )}
      </Menu.Dropdown>
    </Menu>
  );
}
